
export default function ContactMe(){
    return(
        <div>
            <div class="mx-auto max-w-7xl mb-32 px-6 lg:px-8 mt-10">
            <div
                class="relative isolate overflow-hidden bg-gray-900 px-6 py-24 shadow-2xl rounded-2xl sm:rounded-3xl sm:px-24 xl:py-32">
            
                <h2 class="mx-auto max-w-2xl text-center text-3xl font-bold tracking-tight text-white sm:text-4xl">Contact Me Via Whatsapp
                </h2>

                <p class="mx-auto mt-2 max-w-xl text-center text-lg leading-8 text-gray-300">
                Available at all times and I am waiting for your message and correspondence with me.
                </p>

                <form class="mx-auto mt-10 flex max-w-md gap-x-4">

                
                    <button type="submit" class="flex-none rounded-md bg-white px-3.5 py-2.5 text-sm font-semibold text-gray-900 shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white mx-auto hover:bg-[#302D5F] hover:text-white"><a href="https://chatwith.io/s/kerlos-magdy">Send Message</a></button>
                    <button type="submit" class="flex-none rounded-md bg-white px-3.5 py-2.5 text-sm font-semibold text-gray-900 shadow-sm hover:bg-[#302D5F] hover:text-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white mx-auto"><a href="https://drive.google.com/file/d/18AN4f8Uf8fbg9AzWOexjL9mroj8S8kCa/view?usp=drive_link">Download CV</a></button>
                </form>

                <svg viewBox="0 0 1024 1024" class="absolute left-1/2 top-1/2 -z-10 h-[64rem] w-[64rem] -translate-x-1/2"
                    aria-hidden="true">
                    <circle cx="512" cy="512" r="512" fill="url(#759c1415-0410-454c-8f7c-9a820de03641)" fill-opacity="0.7">
                    </circle>
                    <defs>
                        <radialGradient id="759c1415-0410-454c-8f7c-9a820de03641" cx="0" cy="0" r="1"
                            gradientUnits="userSpaceOnUse" 
                            gradientTransform="translate(512 512) rotate(90) scale(512)">
                            <stop stop-color="#7775D6"></stop>
                            <stop offset="1" stop-color="#8257f8" stop-opacity="0"></stop>
                        </radialGradient>
                    </defs>
                </svg>

            </div>
        </div>
        </div>
    )
}